import { render, staticRenderFns } from "./InvoiceWithProduct.vue?vue&type=template&id=63cd29f0&scoped=true&"
import script from "./InvoiceWithProduct.vue?vue&type=script&lang=js&"
export * from "./InvoiceWithProduct.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceWithProduct.vue?vue&type=style&index=0&id=63cd29f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd29f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VDataTable,VProgressLinear})
